import {
  collection,
  CollectionReference,
  doc,
  DocumentReference,
  getFirestore,
} from "firebase/firestore";
import {
  useCollectionData,
  useDocumentData,
} from "react-firebase-hooks/firestore";
import {
  ArtistGroupPrivateSony,
  SonyMusicCountryOptIn,
} from "@max/common/artists";
// Import from the explicit dist path: the portal is on react-scripts 4
// (webpack 4), which ignores package.json "exports", so runtime value imports
// (coveredSonyCountryCodes) must resolve to a real file path.
import {
  coveredSonyCountryCodes,
  SonyTerritoryStatus,
} from "@max/common/dist/creator";

/**
 * Reads whether Sony is enabled for the given artist group and the set of
 * covered Sony territory codes (only when enabled). Powers the non-Sony
 * territory warning in the SET.Live duplication flow. Mirrors the creator app's
 * hook of the same name; the territory logic itself (`isNonSonyTerritory`,
 * `coveredSonyCountryCodes`, `venueCountryCode`) is shared via
 * @max/common/creator so both surfaces agree.
 */
export const useSonyTerritories = (
  artistGroupId?: string,
): SonyTerritoryStatus => {
  const db = getFirestore();

  const [sony] = useDocumentData(
    artistGroupId
      ? (doc(
          db,
          "artist_groups",
          artistGroupId,
          "artist_group_private",
          "sony",
        ) as DocumentReference<ArtistGroupPrivateSony>)
      : undefined,
  );

  const [optIns, optInsLoading, optInsError] = useCollectionData(
    sony?.enabled
      ? (collection(
          db,
          "sony_music_country_optins",
        ) as CollectionReference<SonyMusicCountryOptIn>)
      : undefined,
  );

  return {
    ready: !!sony?.enabled && !optInsLoading && !optInsError,
    coveredCountryCodes: coveredSonyCountryCodes(optIns),
  };
};
